export class DropEvent<T = any> {
    nativeEvent: any;
    dragData: T;

    constructor(event: any, data: T) {
        this.nativeEvent = event;
        this.dragData = data;
    }
}
